/* Admin: Referrals (decision 55, 13 Oct; docs/referrals-spec.md section 4) and the Referrals card on a person's
   page. No board draws them: the admin boards' master brand look, with the shared pieces of styles/admin.css.
   Every colour is a token (styles/tokens.css); small grey text never lighter than --shell-ink-60; gold only as
   the thin bar on a picked line, never carrying text. Under 760px every table is a card per row with the same
   buttons (Adam's answer 5 of 4 Oct), and every control is at least 24px to tap. */

.rf-page { display: flex; flex-direction: column; gap: 20px; min-width: 0; }
.rf-h3 { margin: 0; font-size: 15px; font-weight: 800; }
.rf-muted { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-62); }
.rf-box { border-radius: 14px; border: 1px solid var(--shell-ink-10); background: var(--shell-bg); }
.rf-code {
  display: inline-flex; align-items: center; height: 22px; padding: 0 7px; border-radius: 6px; background: var(--shell-ink-05);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12px; font-weight: 600; color: var(--shell-ink); white-space: nowrap;
}
.rf-text-btn {
  border: none; background: none; padding: 0 2px; min-height: 24px; font: inherit; font-size: 13px; font-weight: 700;
  color: var(--shell-ink); text-decoration: underline; text-underline-offset: 3px; cursor: pointer;
}

/* ---- Introductions ------------------------------------------------------------------------------- */
.rf-owed .ad-card-body { padding-top: 14px; padding-bottom: 14px; }
.rf-owed-list { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 6px 28px; font-size: 15px; font-weight: 700; }
.rf-owed-list a { color: var(--shell-ink); }
/* a refunded sale in a referrer's total and in Mark paid (the review of 18 Oct): said in words, before anyone pays it */
.rf-owed-refunded { font-size: 13px; font-weight: 600; color: var(--shell-ink-62); }
.rf-paid-refunded { margin: 12px 0 0; padding: 10px 12px; border-radius: 10px; border: 1px solid var(--shell-ink-10); background: var(--shell-ink-03);
  font-size: 14px; font-weight: 700; line-height: 1.5; color: var(--shell-ink); max-width: 720px; }
.rf-filters { display: flex; flex-direction: column; gap: 14px; }
.rf-filter-row { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px 16px; flex-wrap: wrap; }
.rf-product-filter { width: 260px; max-width: 100%; }
.rf-count {
  min-width: 20px; height: 20px; padding: 0 6px; border-radius: 10px; background: var(--shell-ink); color: var(--shell-on-ink);
  font-size: 11px; font-weight: 800; display: inline-flex; align-items: center; justify-content: center;
}
.ad-chip[aria-pressed="true"] .rf-count { background: var(--shell-bg); color: var(--shell-ink); }

.rf-table .ad-tr { gap: 12px; padding: 12px 18px; align-items: start; }
.rf-table .ad-thead .ad-tr { align-items: center; }
.rf-line { border-bottom: 1px solid var(--shell-ink-06); }
.rf-line:last-child { border-bottom: none; }
.rf-line > .ad-tr { border-bottom: none; }
.rf-line--picked, .rf-card--picked { box-shadow: inset 4px 0 0 var(--shell-gold); background: var(--shell-ink-025); }
.rf-referred { display: block; }
.rf-referrer { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.rf-referrer-bits { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.rf-status { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; }
.rf-flag { font-size: 12px; font-weight: 700; line-height: 1.4; color: var(--shell-ink); }
.rf-acts-cell { justify-self: end; }
.rf-acts { display: flex; flex-wrap: wrap; justify-content: flex-end; align-items: center; gap: 6px; }
.rf-place { width: 150px; height: 34px; font-size: 13px; }
.rf-ref { font-size: 13px; color: var(--shell-ink-62); }
.rf-after { border-bottom: none; padding-top: 0; }
.rf-note { margin: 0 0 8px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); overflow-wrap: anywhere; }
.rf-after .ad-confirm { margin-top: 2px; }

/* the phone's card per line, and per person on Who can refer */
.rf-cards { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
.rf-card {
  display: flex; flex-direction: column; gap: 12px; padding: 16px; border-radius: 14px;
  border: 1px solid var(--shell-ink-10); background: var(--shell-bg); min-width: 0;
}
.rf-card-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
.rf-card-who { display: flex; flex-direction: column; gap: 2px; min-width: 0; overflow-wrap: anywhere; }
.rf-card-pill { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; text-align: right; }
.rf-card-rows { margin: 0; display: flex; flex-direction: column; gap: 8px; }
.rf-card-rows > div { display: grid; grid-template-columns: 92px minmax(0, 1fr); gap: 10px; align-items: start; font-size: 14px; }
.rf-card-rows dt { font-size: 11px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--shell-ink-60); padding-top: 3px; }
.rf-card-rows dd { margin: 0; min-width: 0; overflow-wrap: anywhere; }
.rf-card .rf-acts { justify-content: flex-start; }
.rf-card--who { flex-direction: row; justify-content: space-between; align-items: flex-start; }
.rf-who-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.rf-who-code { display: flex; }

/* ---- Who can refer -------------------------------------------------------------------------------- */
.rf-who-lede { max-width: 820px; }
.rf-intake { display: flex; align-items: flex-end; gap: 12px; flex-wrap: wrap; }
.rf-intake-field { width: 260px; max-width: 100%; }
.rf-undo-line {
  display: flex; align-items: center; justify-content: space-between; gap: 10px 16px; flex-wrap: wrap; padding: 10px 14px;
  border-radius: 10px; background: var(--shell-ink-03); border: 1px solid var(--shell-ink-10); font-size: 14px; font-weight: 700;
}
.rf-signals { font-size: 14px; line-height: 1.5; color: var(--shell-ink-72); }
.rf-tick { width: 20px; height: 20px; margin: 2px; accent-color: var(--shell-ink); cursor: pointer; flex-shrink: 0; }
.rf-add-someone { display: flex; flex-direction: column; gap: 8px; max-width: 560px; }
.rf-add-label { font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }

/* the person search (Change, Add by hand, Add someone else) */
.rf-search { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.rf-search .ad-search { width: 100%; }
.rf-search-note { font-size: 13px; color: var(--shell-ink-62); }
.rf-search-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; border-radius: 10px; border: 1px solid var(--shell-ink-10); }
.rf-search-row { display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 8px 12px; border-bottom: 1px solid var(--shell-ink-06); }
.rf-search-row:last-child { border-bottom: none; }
.rf-search-who { display: flex; flex-direction: column; min-width: 0; overflow-wrap: anywhere; }
.rf-search-name { font-size: 14px; font-weight: 700; }
.rf-search-email { font-size: 13px; color: var(--shell-ink-60); }
.rf-picked { margin: 0; font-size: 14px; font-weight: 700; }

/* ---- Offers -------------------------------------------------------------------------------------- */
.rf-offers { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; align-items: start; }
.rf-offer .ad-card-head { align-items: center; }
.rf-offer-line { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink-72); }
.rf-offer-note { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }
.rf-offer-acts { display: flex; gap: 8px; flex-wrap: wrap; }
.rf-offer-form { gap: 14px; }
.rf-row-3 { --ad-row-cols: 3; }
.rf-warn { display: block; font-size: 12px; font-weight: 700; line-height: 1.5; color: var(--shell-ink); }

/* ---- The person page's card ----------------------------------------------------------------------- */
.rf-pc-code { margin: 0; font-size: 14px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.rf-pc-part { display: flex; flex-direction: column; gap: 8px; }
.rf-pc-ticks { display: flex; flex-wrap: wrap; gap: 8px 22px; }
.rf-pc-lines { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.rf-pc-line { display: flex; align-items: center; gap: 8px 12px; flex-wrap: wrap; padding: 8px 0; border-bottom: 1px solid var(--shell-ink-06); font-size: 14px; }
.rf-pc-line:last-child { border-bottom: none; }
.rf-pc-line-text { font-weight: 700; }
.rf-pc-amount { font-weight: 700; }
.rf-pc-open { margin-left: auto; font-size: 13px; font-weight: 700; color: var(--shell-ink); display: inline-flex; align-items: center; min-height: 24px; }
.rf-pc-by { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-72); }

@media (max-width: 1100px) {
  .rf-offers { grid-template-columns: minmax(0, 1fr); }
}

@media (max-width: 760px) {
  .rf-page { gap: 16px; }
  .rf-filter-row { align-items: stretch; flex-direction: column; }
  .rf-product-filter, .rf-intake-field { width: 100%; }
  .rf-intake { flex-direction: column; align-items: stretch; }
  .rf-row-3 { --ad-row-cols: 1; }
  .rf-place { width: 100%; height: 40px; }
  .rf-acts { justify-content: flex-start; }
  .rf-tick { width: 24px; height: 24px; margin: 0; }
  .rf-pc-open { margin-left: 0; }
  .rf-owed-list { flex-direction: column; }
  .rf-owed-list a { display: inline-flex; align-items: center; min-height: 24px; }
}
